export const layouts = {
  /* default: [
    "` 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
    "{tab} q w e r t y u i o p [ ] \\",
    "{lock} a s d f g h j k l ; ' {enter}",
    "{shift} z x c v b n m , . / {shift}",
    ".com @ {space}",
  ], */
  default: [
    "0 1 2 3 4 5 6 7 8 9 ö ü ó {bksp}",
    "{tab} q w e r t z u i o p ő ú \\",
    "{lock} a s d f g h j k l é á ű {enter}",
    "{shift} í y x c v b n m , . / {shift}",
    ".com @ {space}",
  ],
  shift: [
    "0 1 2 3 4 5 6 7 8 9 Ö Ü Ó {bksp}",
    "{tab} Q W E R T Z U I O P Ő Ú \\",
    "{lock} A S D F G H J K L É Á Ű {enter}",
    "{shift} Í Y X C V B N M , . / {shift}",
    ".com @ {space}",
  ],
};
